import { useFlag } from '@unleash/proxy-client-react';
import { useEffect } from 'react';

import metrics from '../services/metrics';

const useMixpanelFlag = (flagName: string) => {
  const isEnabled = useFlag(flagName);

  useEffect(() => {
    metrics.setFlag(flagName, isEnabled);
  }, [isEnabled, flagName]);

  return isEnabled;
};

export default useMixpanelFlag;
